const globalEvent = {
  stompClient: {
    CONNECTING: 'stompClient.connecting',
    CONNECTED: 'stompClient.connected',
    DISCONNECTED: 'stompClient.disconnected',
    RECEIVE: 'stompClient.receive',
    SEND: 'stompClient.send'
  },
  templateGrid: {
    DATA_LOAD: 'templateGrid.dataLoad',
    DATA_CHANGED: 'templateGrid.dataChanged',
    DATA_STATE_CHANGED: 'templateGrid.dataStateChanged',
    ROW_CLICK: 'templateGrid.rowClick',
    ROW_DBLCLICK: 'templateGrid.rowDblclick'
  },
  templateGridPopoverPage: {
    RELOAD_GRID_DATA: 'reloadGridData',
    HIDE_POPOVER: 'hidePopover',
    HIDE_POPOVER_AND_REFRESH: 'hidePopoverAndRefresh'
  }
}

export default globalEvent
